class ProductPage {
  constructor(parent) {
    if (parent.length === 0) {
      return
    }
    this.parent = parent;
    this.init();
  }


  clickEvent = () => {
    document.addEventListener("click",(e) => {
      let that = e.target;
      if (that.closest(".product-det-sec") || that.classList.contains("product-det-sec")) {
        that.closest(".product-det-sec")?.classList?.toggle("active-tab");
        that.closest(".pdp-collapse")?.querySelector(".product-det-block")?.classList?.toggle("show-content");
      } else if(that.classList.contains("pswp__button--close") || that.closest(".pswp__button--close")) {
        if(window.innerWidth < 767) {
          // Hide div and then after click close button
          document.querySelector(".pswp")?.classList?.add("hide");
          document.querySelector(".pswp__button--close").click();
        }
      }
    })
  }

  init = () => {
    if(window.innerWidth > 768) {
      CloudZoom?.quickStart();
    }
    this.clickEvent();
  }
  
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductPage(document.querySelectorAll('.main-product-wrapper'));
}, false);